export default __webpack_public_path__ + "static/media/Cartão Pequenos Artistas - Cat. I.e9fe942f.png";